export function ActividadProgramaArchivoField({
  label,
  accept,
  inputId,
  selectedFile,
  onFileChange,
  currentNombre,
}: {
  label: string;
  accept: string;
  inputId: string;
  selectedFile: File | null;
  onFileChange: (file: File | null) => void;
  currentNombre?: string | null;
}) {
  return (
    <div className="md:col-span-2">
      <label className="block text-sm font-medium mb-2">{label}</label>
      <div className="flex flex-col gap-2">
        <label
          htmlFor={inputId}
          className="cursor-pointer px-4 py-2 rounded bg-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-200 transition flex items-center gap-2"
        >
          <svg
            className="w-5 h-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12"
            />
          </svg>
          <span>
            {selectedFile ? "Cambiar archivo" : "Selecciona un archivo"}
          </span>
        </label>
        <input
          id={inputId}
          type="file"
          accept={accept}
          className="hidden"
          onChange={(e) => {
            onFileChange(e.target.files?.[0] ?? null);
          }}
        />
        {!selectedFile && currentNombre ? (
          <span className="text-xs text-gray-500 mt-1">
            Archivo actual: {currentNombre}
          </span>
        ) : null}
      </div>
    </div>
  );
}
